const domain = 'console.careconnect-dev.netsmartexchange.com';
const apiDomain = 'careconnect-dev.netsmartexchange.com';

export const environment = {
  apiUrl: `https://${apiDomain}/api`,
  baseUrl: `https://${domain}`,
  ccnxUrl: `https://${apiDomain}`,
  oktaConfig: {
    clientId: `0oa1s6mualu3OSBAD1d8`,
    issuer: `https://ntstcareconnect.okta.com`,
    redirectUri: `https://${domain}/oidc/callback`,
    postLogoutRedirectUri: `https://${domain}/loggedout`,
  },
};
